import { Role } from "@/types/auth";

export const ROLE_HIERARCHY: Record<Role, number> = {
  [Role.ADMIN]: 6,
  [Role.SENIOR]: 5,
  [Role.COMPTABLE]: 4,
  [Role.BOUTIQUE]: 3,
  [Role.FLEURISTE]: 2,
  [Role.PREPARATEUR]: 2,
  [Role.ATELIER]: 2,
  [Role.LIVREUR]: 1,
};
